import React from "react";

const SubmitButton = ({
  isSubmitting,
  label = "送信",
  className = "",
  type = "submit",
  onClick,
  children,
  wrap = true
}) => {
  const button = (
    <button type={type} onClick={onClick} disabled={isSubmitting}>
      <span>{children || label}</span>
    </button>
  );

  return wrap ? (
    <div className={`submit-button-wrapper ${className}`}>
      {button}
      {isSubmitting && <span className="loading-overlay" />}
    </div>
  ) : (
    <>
      {button}
      {isSubmitting && <span className="loading-overlay" />}
    </>
  );
};

export default SubmitButton;
